// removed by extract-text-webpack-plugin
module.exports = {"card-header-link":"WaitingRoomLink__card-header-link___3sMu4","checkout-icon":"WaitingRoomLink__checkout-icon___2fCZ6","disabled":"WaitingRoomLink__disabled___2qXdJ"};